import React from "react";
import { Form, Checkbox, Icon } from "semantic-ui-react";

class Occupancy extends React.Component {
  state = { visible: false };
  toggleVisible = () =>
    this.setState(prevState => ({ visible: !prevState.visible }));
  render() {
    const {
      label,
      disabled,
      occur,
      personsAdult,
      occupancy,
      personsCategoryAge1,
      personsCategoryAge2,
      personsCategoryAge3,
      onFieldChange,
      t
    } = this.props;

    return (
      <Form>
        <Form.Field>
          <Checkbox
            toggle
            label={label}
            disabled={disabled}
            onChange={(e, data) =>
              onFieldChange(occupancy, "occur", data.checked)
            }
            checked={occur}
          />
        </Form.Field>
        <Form.Group unstackable widths={2}>
          <Form.Input
            onChange={e =>
              onFieldChange(occupancy, "personsAdult", e.target.value)
            }
            value={personsAdult}
            disabled={disabled || !occur}
            fluid
            width="13"
            //label={t("occupancy:adultsCount")}
          />
          <Form.Button icon basic width="3" onClick={this.toggleVisible}>
            <Icon name={this.state.visible ? "minus" : "plus"} />
          </Form.Button>
        </Form.Group>

        {this.state.visible && (
          <Form.Group widths="equal">
            <Form.Input
              onChange={e =>
                onFieldChange(occupancy, "personsCategoryAge1", e.target.value)
              }
              value={personsCategoryAge1}
              disabled={disabled || !occur}
              fluid
              label={t("occupancy:categoryAge1Count")}
            />
            <Form.Input
              onChange={e =>
                onFieldChange(occupancy, "personsCategoryAge2", e.target.value)
              }
              value={personsCategoryAge2}
              disabled={disabled || !occur}
              fluid
              label={t("occupancy:categoryAge2Count")}
            />
            <Form.Input
              onChange={e =>
                onFieldChange(occupancy, "personsCategoryAge3", e.target.value)
              }
              value={personsCategoryAge3}
              disabled={disabled || !occur}
              fluid
              label={t("occupancy:categoryAge3Count")}
            />
          </Form.Group>
        )}
      </Form>
    );
  }
}

export default Occupancy;



// WEBPACK FOOTER //
// ./src/rooms/HotelStructure/Occupancy.js